module.exports = __webpack_public_path__ + "static/assets/dec3d7b939bf2ebe22dd057b6b113993.png";